import axios from "axios";
import {formatoMoneda} from "../Utilidades/formatoMoneda";

export const solicitarMensajeGuia = ({pedido}) => {


    let data = JSON.stringify({
        "idPedido": pedido.idPedido,
        "estadoPago":pedido.estadoPago
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/bc321ae5-a98d-42b5-9397-2559bfd98beb', //test
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/bc321ae5-a98d-42b5-9397-2559bfd98beb',
        headers: {
            'Content-Type': 'application/json'
        },
        data : data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}